import React from 'react'
import { ApexCharts } from '../../../../Components'
import { LogAcessoGetAcessosPorVersaoApp } from '../../../../Service/ApiService'
import ChartCard from '../ChartCard'
import { CORES, formatarNumero, useIndicador } from '../helpers'

export default function AcessosPorVersaoApp({ filters }) {
  const { status, data } = useIndicador(LogAcessoGetAcessosPorVersaoApp, filters, (d) => !d.data?.length)
  const versoes = data?.labels?.map((versao) => versao || 'Não informada') || []

  const options = {
    chart: { type: 'bar' },
    colors: [CORES.azul],
    plotOptions: { bar: { horizontal: true, barHeight: '60%', borderRadius: 3 } },
    dataLabels: { enabled: true, formatter: formatarNumero, style: { fontSize: '11px' } },
    xaxis: { categories: versoes, labels: { formatter: formatarNumero } },
    tooltip: { y: { formatter: formatarNumero } },
  }

  const altura = Math.max(280, versoes.length * 26 + 60)

  return (
    <ChartCard title="Acessos por versão do app" subtitle="Versões mais usadas primeiro" status={status}>
      <ApexCharts options={options} series={[{ name: 'Acessos', data: data?.data || [] }]} type="bar" height={altura} />
    </ChartCard>
  )
}
